<div class="footer-nav" [class.on]="!!navState">
    <div class="title" *ngIf="navState">{{navState.title}}</div>
    <ul class="nav-items">
        <li class="nav-item" *ngFor="let item of footerNavStates">
            <a class="nav-link" (click)="playSound($event)" [routerLink]="[ item.url ]" [ngStyle]="{ 'background-color': item.color }" [class.active]="item.active">
                <img class="nav-img" [src]="item.iconUrl" [alt]="item.title" />
            </a>
        </li>
    </ul>
</div>